module.exports = __webpack_public_path__ + "media/images/partners/universite-agadez-d03502507bf2b76729e6a1fb547d49f7.png";